<template>
  <div class="edit-change-password">
    <slot name="txtBefore"></slot>
    <b-form
      class="change-password-edit-form"
      ref="form"
      :id="'form' + _uid"
    >
      <div>
        <b-form-group label="old password" label-class="visually-hidden">
          <Password
            ref="Password"
            name="old"
            :password.sync="oldPassword_"
            :validate="false"
            :invalid.sync="invalidOld"
          >
            <template v-for="slot in possibleChildSlotsFor('Old')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </Password>
        </b-form-group>
      </div>
      <hr>
      <PasswordWithRepeat
        ref="PasswordWithRepeat"
        :password.sync="newPassword_"
        :repeat.sync="passwordRepeat"
        :invalid.sync="invalidNew"
      >
        <template v-for="slot in possibleChildSlotsFor('New')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </PasswordWithRepeat>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { BForm } from 'bootstrap-vue'
import Password from '../Password.vue'
import PasswordWithRepeat from '../PasswordWithRepeat.vue'
import slotProxy from '../../../../../mixins/slotProxy'
import syncProperty from '../../../../../mixins/syncProperty'

export const stepName = 'input'

export default {
  name: 'ChangePasswordEdit',
  data () {
    return {
      passwordRepeat: '',
      invalidOld: true,
      invalidNew: true,
      loadingNext: false
    }
  },
  components: {
    PasswordWithRepeat,
    Password,
    BForm
  },
  watch: {
    invalid: {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  computed: {
    invalid () {
      return this.invalidOld || this.invalidNew
    }
  },
  methods: {
    async reset () {
      await Promise.all([
        this.$refs.Password.reset(),
        this.$refs.PasswordWithRepeat.reset()
      ])
      // Firefox also needs the form to be reseted
      this.$refs.form.reset()
    }
  },
  mixins: [
    syncProperty('oldPassword', 'oldPassword_'),
    syncProperty('newPassword', 'newPassword_'),
    slotProxy()
  ]
}
</script>
